// Copyright 2026, Imprivata, Inc.  All rights reserved.

// Keys
export const SessionStorageKeys = {
  PASSWORD_EXPIRATION_DISMISSED_PORTAL: 'password-expiration-dismissed-portal',
  PASSWORD_EXPIRATION_DISMISSED_MII: 'password-expiration-dismissed-mii',
  MFA_ENROLLMENT_BANNER_DISMISSED: 'mfa-enrollment-banner-dismissed',
} as const;

// Functions
export const resetPasswordExpirationBanner = () => {
  sessionStorage.removeItem(SessionStorageKeys.PASSWORD_EXPIRATION_DISMISSED_PORTAL);
  sessionStorage.removeItem(SessionStorageKeys.PASSWORD_EXPIRATION_DISMISSED_MII);
};

export const resetMfaEnrollmentBanner = () => {
  sessionStorage.removeItem(SessionStorageKeys.MFA_ENROLLMENT_BANNER_DISMISSED);
};
